import * as Electron from "@/steam/bindings/electron";

export function openExternalLink(url) {
  if (Electron.isModuleLoaded()) {
    // Electron.openExternal(url);
  } else {
    // eslint-disable-next-line capitalized-comments
    // window.open(url, "_blank").focus();
  }
  throw new Error(`Tried to open ${url}, but blocked because of Yandex`);
}
